import 'slick-carousel'  ;
import React from 'react';
import ReactDOM from 'react-dom';
import Member from './component/member';
import ArtObject from './component/art-object';

$('[data-main-slider]').slick({
    draggable: false,
    prevArrow: '<button class="slider__arrow slider__arrow_left"></button>',
    nextArrow: '<button class="slider__arrow slider__arrow_right"></button>',
});

const classMap = {
    'MemberEdit': Member,
    'ArtObjectEdit': ArtObject
};

for(let i in classMap) {
    if(classMap.hasOwnProperty(i) && document.getElementById(i)) {
        const Item = classMap[i];
        ReactDOM.render(<Item/>, document.getElementById(i));
    }
}






// WEBPACK FOOTER //
// ./bundle/app.js